<template>
    <br-table
            :columns="postLeadTable.columns"
            :options="postLeadTable.options"
            order-by="updated_at"
            :per-page="15"
            sort-by="desc"
            :url="postLeadEndpoint"
            ref="table">>
        <template slot="uploaded" slot-scope="{row}">
            {{ !row.uploaded ? 'Failure' : (row.missing_columns != null ? 'Received' : 'Success') }}
        </template>
        <template slot="updated_at" slot-scope="{row}">
            {{ row.updated_at | dateTime }}
        </template>
        <template slot="user.first_name" slot-scope="{row}">
            {{ row.user ? row.user.first_name + ' ' + row.user.last_name : 'N/A' }}
        </template>
    </br-table>
</template>
<script>

    import VueStrap from 'vue-strap'

    export default {

        data: () => ({
            postLeadTable: {
                columns: [
                    'uploaded',
                    'updated_at',
                    'user.first_name',
                ],
                options: {
                    headings: {
                        'uploaded': 'Status',
                        'user.first_name': 'Full Name',
                        'updated_at': 'Date',
                    },
                    columnsClasses: {
                        'actions': 'text-center'
                    }

                }
            }
        }),
        computed: {
            postLeadEndpoint() {
                return '/api/post-lead/report'
            }
        },
        components: {
            BsModal: VueStrap.modal
        }
    }
</script>
